import * as React from 'react';
import { BaseComponent } from './BaseComponent';
import { LayoutType } from '../constants/LayoutConstants';
import { SidebarModule, HamburgerTab } from '../constants/Enums';
import { ViewSettingsStore } from '../stores/ViewSettingsStore';
import { ProjectManagerStore } from '../stores/ProjectManagerStore';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';
import { ViewSettingsActions } from '../actions/ViewSettingsActions';
import { ClickButton } from './ClickButton';

interface HamburgerButtonProps {
    layoutType: LayoutType;
    sidebarOrientation: string;
}

interface HamburgerButtonState {
    sidebar: SidebarModule;
    hamburgerTab: HamburgerTab | null;
    hide: boolean;
    editMode: boolean;
}

const enum HamburgerButtonType {
    STANDARD = 1,
    GOTOPOPUP = 2,
    CLOSEPOPUP = 3,
    POPUPISOPEN = 4,
    SIDEBARISOPEN = 5
}

export class HamburgerButton extends BaseComponent<HamburgerButtonProps, HamburgerButtonState> {
    public componentWillMount(): void {
        this.addStoreListener(ViewSettingsStore, this.onChange);
        this.addStoreListener(ProjectManagerStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (
            this.state.hide ||
            (
                AppConfigurationStore.getState().inApp &&
                (this.props.layoutType === LayoutType.SMALL || AppConfigurationStore.getState().singleHamburgerTabs) &&
                this.state.hamburgerTab != null &&
                this.state.hamburgerTab !== HamburgerTab.MENU
            )
        ) {
            return null;
        }
        return (
            <ClickButton
                className={this.getCSSClass()}
                callback={this.click}
                key="hamburger-button"
            />
        );
    }

    protected onChange = (): void => {
        this.setState({
            sidebar: ViewSettingsStore.getState().sidebar,
            hamburgerTab: ViewSettingsStore.getState().hamburgerTab,
            hide: ViewSettingsStore.getState().hideBars,
            editMode: ProjectManagerStore.getState().editMode
        });
    };

    protected click = (): void => {
        const buttonType: HamburgerButtonType = this.getType();
        let targetTab: HamburgerTab = HamburgerTab.MENU;
        if (
            this.props.layoutType === LayoutType.DESKTOP &&
            !AppConfigurationStore.getState().inApp
        ) {
            targetTab = HamburgerTab.SETTINGS;
        }
        switch (buttonType) {
            case HamburgerButtonType.STANDARD:
                ViewSettingsActions.changeHamburger(targetTab);
                break;
            case HamburgerButtonType.GOTOPOPUP:
                ViewSettingsActions.changeHamburger(targetTab);
                break;
            case HamburgerButtonType.SIDEBARISOPEN:
                ViewSettingsActions.changeHamburger(targetTab);
                break;
            case HamburgerButtonType.CLOSEPOPUP:
                ViewSettingsActions.changeHamburger(null);
                break;
            default:
                break;
        }
    };

    protected getCSSClass = (): string => {
        const buttonType: HamburgerButtonType = this.getType();
        let result: string = 'hamburger-button';
        switch (buttonType) {
            case HamburgerButtonType.STANDARD:
                break;
            case HamburgerButtonType.GOTOPOPUP:
                result += ' back-to-popup';
                break;
            case HamburgerButtonType.CLOSEPOPUP:
                result += ' popup-open';
                break;
            case HamburgerButtonType.SIDEBARISOPEN:
                result += ' hamburger-button-sidebartab-open';
                break;
            default:
                break;
        }
        if (!AppConfigurationStore.getState().projectManagerAvailable) {
            result += ' no-pm';
        }
        if (this.state.editMode) {
            result += ' hamburger-button-project-editmode';
        }
        result += (this.props.sidebarOrientation === 'right' ? ' on-right-side' : '');
        return result;
    };

    protected getType = (): HamburgerButtonType => {
        if (this.state.hamburgerTab != null) {
            return HamburgerButtonType.CLOSEPOPUP;
        }
        if (this.state.hamburgerTab == null && this.state.sidebar === SidebarModule.NONE) {
            return HamburgerButtonType.GOTOPOPUP;
        }
        if (this.state.sidebar !== SidebarModule.NONE && this.state.sidebar !== SidebarModule.PROJECTS) {
            return HamburgerButtonType.SIDEBARISOPEN;
        }
        return HamburgerButtonType.STANDARD;
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/HamburgerButton.tsx